module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_10X_IDC.a69fe144.png";